import { fromJS } from 'immutable';

import {
  SET_ASSET_PAGE_BACK_LINK,
} from './constants';

const initialState = fromJS({
  backLink: null,
});

function analyticsAssetReducer(state = initialState, action) {
  switch (action.type) {
  case SET_ASSET_PAGE_BACK_LINK:
    return state
      .set('backLink', action.backLink);
  default:
    return state;
  }
}

export default analyticsAssetReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset/reducer.js
 **/